import { Button } from "@/components/ui/button/button";
import FileIcon from "@/components/ui/icons/file-icon";
import { formatBytes } from "@/libs/file-helper";

type UnsupportedPreviewAttachmentProps = {
  fileName: string;
  fileSize?: number;
  href: string;
};

function UnsupportedPreviewAttachment({
  fileName,
  fileSize,
  href,
}: UnsupportedPreviewAttachmentProps) {
  const fileSizeFormat = formatBytes(fileSize ?? 0);
  return (
    <div className="max-w-full mt-5">
      <div className="flex items-center gap-4 p-2 whitespace-nowrap">
        <div className="flex items-center max-w-full gap-4 overflow-hidden text-left">
          <div className="flex-shrink-0">
            <FileIcon fileNameOrExtension={fileName} size={24} />
          </div>
          <div className="flex-1 overflow-hidden">
            <a href={href} download={true} target="_blank" rel="noreferrer">
              <p className="overflow-hidden text-text-light text-ellipsis whitespace-nowrap">
                {fileName}
              </p>
            </a>
            <p className="text-text-light/64">{fileSizeFormat}</p>
          </div>
        </div>
        <a
          href={href}
          download={true}
          target="_self"
          rel="noreferrer"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Button>Download</Button>
        </a>
      </div>
    </div>
  );
}

export default UnsupportedPreviewAttachment;
